var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 7.385h-3.323a1.3 1.3 0 0 1-1.3-1.3V2.5M20 7.385 15.377 2.5M20 7.385V18.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-.193l.043-11.55V5.5a3 3 0 0 1 3-3h8.334m-8 9.692h9.26m-9.26 2.53h4.263m4.997 3.063v0a.81.81 0 0 1-1.28-.246l-.02-.044a.423.423 0 0 0-.77.018l-.334.786a.404.404 0 0 1-.684.099l-.307-.375a.91.91 0 0 0-1.46.073v0M8.419 5.772h2.105a1 1 0 0 1 1 1v1.922a1 1 0 0 1-1 1H8.42a1 1 0 0 1-1-1V6.772a1 1 0 0 1 1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.786d96110278f97b3d6d8c46a3de4883.svg";
export { ForwardRef as ReactComponent };